import React, { useEffect, useState } from "react";

const DepositReqCard = ({ data }) => {
  const [depositDate, setDepositDate] = useState();
  useEffect(() => {
    const date = new Date(data?.createdAt);
    const options = {
      month: "long", // Full month name
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // Enable am/pm formatting
    };
    const formattedDate = date
      .toLocaleString("en-US", options)
      .replace(",", "");
    console.log(formattedDate);
    setDepositDate(formattedDate);

    return () => {};
  }, []);

  return (
    <>
      <td
        className={`pl-2 whitespace-no-wra ${
          data?.status == "inProgress" ? "bg-orange-400" : ""
        }`}
      >
        <div className="text-white">Date</div>
        <div className="text-white"> {depositDate}</div>
      </td>

      <td className="px-2 py-2 whitespace-no-wrap">
        <div className="leading-5 text-white flex items-center">
          <h2 className="text-sm">{data?.user?.name}</h2>
          <p className="text-blue-500 font-bold bg-white rounded p-1 hover:underline ms-5">
            {data?.depositId ? data?.depositId : data?.withdrawId}
          </p>
        </div>
        <div className="leading-5 text-white">
          This is a new {data?.depositId ? "Deposit" : "Withdraw"}request For
          EasyPaisa
        </div>
        <div className="leading-5 text-white">
          <p>
            {data?.user?.pubgName} requested for a{" "}
            {data?.depositId ? "Deposit" : "Withdraw"} of{" "}
          </p>
          <div className="">
            <p className="text-sm text-blue-500 font-bold ">
              {data?.easypaisaAmount} PKR
            </p>
          </div>
        </div>
      </td>
    </>
  );
};

export default DepositReqCard;
